import { render, staticRenderFns } from "./ErrorReportDialog.vue?vue&type=template&id=979aae40&"
import script from "./ErrorReportDialog.vue?vue&type=script&lang=ts&"
export * from "./ErrorReportDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports